<template>
  <b-modal :id="modalId" modal-class="modal-min-age" centered size="sm"
           @ok="acceptMinAgePrivacy"
           hide-header no-close-on-backdrop no-close-on-esc>
    <div class="d-block text-center">
      <h1 class="modal-title pb-2">
        {{ $t('modal_min_age.title') }}
      </h1>
      <div class="px-4 pt-3 pb-3 d-flex">

        <b-button variant="primary" class="flex-grow-1 mx-1 btn-selector" @click="hasMinimumAge=false"
                  :class="{'on': hasMinimumAge!==undefined && !hasMinimumAge}">
          {{ $t('modal_min_age.not_accept') }}
        </b-button>
        <b-button variant="primary" class="flex-grow-1 mx-1 btn-selector" @click="hasMinimumAge=true"
                  :class="{'on': hasMinimumAge}">
          {{ $t('modal_min_age.accept') }}
        </b-button>
      </div>
      <div class="px-4 pb-2 text-left">
        <b-form-checkbox v-model="hasAccepted" :required="true"
                         :value="true"
                         :unchecked-value="false">
          <span class="text" v-html="privacyText"></span>
        </b-form-checkbox>
      </div>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="w-100">
        <div class="d-sm-flex justify-content-center">
          <div class="flex-grow-1 px-4">
            <b-button class="btn-ok" block @click="ok" :disabled="isDisabled">
              {{ $t('modal_min_age.ok') }}
            </b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>


<script>

import {mapGetters, mapMutations} from "vuex";

export default {

  props: {
    modalId: {
      type: String,
      default: 'modal-minimum-age'
    },
  },

  data() {
    return {
      hasMinimumAge: undefined,
      hasAccepted: false
    }
  },
  computed: {
    ...mapGetters(['thirdLevelDomain', 'minRequiredAgeAccepted']),
    ...mapGetters('appConfig', ['minRequiredAgePolicyUrl']),
    isDisabled() {
      return this.hasMinimumAge === undefined || !this.hasMinimumAge || !this.hasAccepted
    },
    privacyText() {
      return this.$t('modal_min_age.privacy_text', {
        event_owner: this.thirdLevelDomain,
        policy_url: this.minRequiredAgePolicyUrl
      })
    }
  },

  mounted() {
    if (!this.minRequiredAgeAccepted) {
      this.$bvModal.show(this.modalId)
    }
  },

  methods: {
    ...mapMutations(['SET_MIN_REQUIRED_AGE_ACCEPTED']),
    acceptMinAgePrivacy() {
      this.SET_MIN_REQUIRED_AGE_ACCEPTED(this.hasMinimumAge)
      this.$bvModal.hide(this.modalId)
    }
  }

}
</script>

